/**
 * File Field File Status enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum FILE_FIELD_FILE_STATUS {
	WAITING = "WAITING",
	UPLOADING = "UPLOADING",
	UPLOADED = "UPLOADED",
	ERROR = "ERROR"
}

export type FILE_FIELD_FILE_STATUS_string = keyof typeof FILE_FIELD_FILE_STATUS;

export const FILE_FIELD_FILE_STATUS_default: FILE_FIELD_FILE_STATUS_string = "WAITING";
